var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner" },
    [
      _c("div", { staticClass: "app-main-inner-row" }, [
        _c(
          "div",
          { staticClass: "triggers" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    return _vm.showEditDialog(true)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    return _vm.showEditDialog(false)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
            ),
            _c(
              "el-button",
              { attrs: { type: "danger" }, on: { click: _vm.remove } },
              [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "app-main-inner-row row-grid" },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%" },
            attrs: {
              "grid-options": _vm.gridOptions,
              "side-bar": _vm.sideBarDefs,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: { gridReady: _vm.onGridReady }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.editDialog.title,
            width: "400px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Charge" } },
                    [
                      _c(
                        "el-select",
                        {
                          on: { change: _vm.changeChargeItemHandler },
                          model: {
                            value: _vm.editDialog.form.chargeItem,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "chargeItem", $$v)
                            },
                            expression: "editDialog.form.chargeItem"
                          }
                        },
                        _vm._l(_vm.chargeList, function(item) {
                          return _c("el-option", {
                            key: item.chargeItemCode,
                            attrs: {
                              label: item.chargeItemCode,
                              value: item.chargeItemCode
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Unit Rate" } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          min: 0,
                          precision: 2,
                          "controls-position": "right"
                        },
                        model: {
                          value: _vm.editDialog.form.unitRate,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "unitRate", $$v)
                          },
                          expression: "editDialog.form.unitRate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Measure" } },
                    [
                      _c(
                        "el-select",
                        {
                          on: { change: _vm.onMeasureChange },
                          model: {
                            value: _vm.editDialog.form.measure,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "measure", $$v)
                            },
                            expression: "editDialog.form.measure"
                          }
                        },
                        _vm._l(_vm.measures, function(item) {
                          return _c("el-option", {
                            key: item.code,
                            attrs: {
                              label:
                                _vm.$store.getters.language === "zh"
                                  ? item.chineseName
                                  : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Min Amount" } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          min: 0,
                          precision: 2,
                          "controls-position": "right"
                        },
                        model: {
                          value: _vm.editDialog.form.minAmount,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "minAmount", $$v)
                          },
                          expression: "editDialog.form.minAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Remark" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.editDialog.form.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "remark", $$v)
                          },
                          expression: "editDialog.form.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.save } },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }